// import { general_routes } from "./general";
var routes = [
  {
    path: "/affiliate",
    redirect: "/affiliate/dashboard",
    component: () => import("@/views/theme/Base"),
    meta: { section: "affiliate" },
    children: [
      {
        path: "dashboard",
        name: "affiliate-dashboard",
        meta: { section: "affiliate" },
        component: () => import("@/views/pages/affiliate/Dashboard.vue")
      }
    ]
  },
  {
    path: "/affiliate",
    component: () => import("@/views/pages/auth/Auth1"),
    meta: { section: "affiliate" },
    children: [
      {
        name: "affiliate-login",
        path: "login",
        meta: { section: "affiliate" },
        component: () => import("@/views/pages/auth/Login1")
      },
      {
        name: "affiliate-register",
        path: "register",
        meta: { section: "affiliate" },
        component: () => import("@/views/pages/auth/Register1")
      }
    ]
  },
  {
    path: "/affiliate/404",
    name: "affiliate-404",
    meta: {
      section: "affiliate"
    },
    component: () => import("@/views/pages/error/Error-1.vue")
  }
  //   ,
  //   ...general_routes("affiliate-", { section: "affiliate" })
];

export const affiliate_routes = routes;
